import { MainView } from '@repo/ui/Views';
import ApiKeysTable from '../components/ApiKeysTable';
import CreateApiKeySheet from '../components/CreateApiKeySheet';
import { useUser } from '@repo/hooks/useUser';
import { POLICIES, Authorization } from '@/lib/Authorization';
import { FallbackCard } from '@repo/ui/Card';
import { useAccount } from '@/hooks/useAccount';

import { Card } from '@repo/ui/Card';
import { QuickLinks } from '@repo/ui/QuickLinks';
import { QuickLinkType } from '@repo/ui/QuickLinks';
import { CopyPasteField } from '@repo/ui/CopyPasteField';

const DevelopPage = () => {
  const user = useUser();
  const account = useAccount();
  const accountId = account.id;
  const normalizedAccountId = Array.isArray(accountId) ? accountId[0] : accountId;

  const links: QuickLinkType[] = [
    {
      title: 'API Docs',
      href: 'https://docs.swiftsmsgateway.com',
      external: true,
      description: 'Everything you need to get building.',
      icon: 'article',
    },

    ...(account.legacyAccess
      ? [
          {
            title: 'SMS Legacy Docs',
            href: 'https://secure.smsgateway.ca/docs/index.html#introduction1',
            external: true,
            icon: 'book',
          },
        ]
      : []),
  ];

  return (
    <MainView title={`${account.name} API Keys`}>
      <Card title="Development resources" size="sm">
        <QuickLinks links={links}>
          <CopyPasteField
            label="API Account ID"
            description="Your API account ID may be required for certain API requests in addition to your API key(s)."
            descriptionExplicit
            text={normalizedAccountId ?? ''}
            size="lg"
          />
        </QuickLinks>
      </Card>
      <Authorization
        policyCheck={POLICIES['api_keys:index'](user)}
        fallbackView={
          <FallbackCard
            title="No Access"
            description="You do not have the permissions to view API keys."
          />
        }
      >
        {normalizedAccountId && POLICIES['api_keys:create'](user) && (
          <div className="flex justify-end">
            <CreateApiKeySheet accountId={normalizedAccountId} />
          </div>
        )}
        <ApiKeysTable accountId={normalizedAccountId} />
      </Authorization>
    </MainView>
  );
};

export default DevelopPage;
